import axios from "@/utils/axiosHelper";

// 初始化
export const onInitAPI = params => {
  return axios(
    { url: "/lantern/new/year/init", method: "GET", params },
    { interceptResultCode: false }
  );
};

// 领取彩蛋
export const onEggRewardAPI = params => {
  return axios(
    { url: "/lantern/new/year/reward", method: "POST", params },
    { interceptResultCode: false }
  );
};

// 领取彩蛋
export const lotteryDataAPI = params => {
    return axios(
      { url: "/lantern/new/year/lottery", method: "POST", params },
      { interceptResultCode: false }
    );
  };

// 预约游戏
export const appointAPI = params => {
  return axios(
    { url: "/lantern/new/year/book", method: "POST", params },
    { interceptResultCode: false }
  );
};


// 做任务
export const doTaskAPI = params => {
    return axios(
      { url: "/lantern/new/year/task", method: "POST", params },
      { interceptResultCode: false }
    );
  };


// 领取任务奖励
export const getRewardAPI = params => {
    return axios(
      { url: "/lantern/new/year/task/get", method: "POST", params },
      { interceptResultCode: false }
    );
  };


// WEBPACK FOOTER //
// ./src/pages/tideng/ani-appoint/api.js